// extracted by mini-css-extract-plugin
export default {"similarDriversModal":"SimilarDriversModal_similarDriversModal__ikGpk","modalContent":"SimilarDriversModal_modalContent__MMLUe","topButtonArea":"SimilarDriversModal_topButtonArea__LWJFb"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"similarDriversModal\":\"SimilarDriversModal_similarDriversModal__ikGpk\",\"modalContent\":\"SimilarDriversModal_modalContent__MMLUe\",\"topButtonArea\":\"SimilarDriversModal_topButtonArea__LWJFb\"}";
        // 1793760840607
        var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  